import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/AuthSlice";
import usersReducer from "./users/UsersSlice";
import classesReducer from "./classes/ClassesSlice";
import studentsReducer from "./students/StudentsSlice";
import attendanceReducer from "./attendance/AttendanceSlice";
import schoolsReducer from "./schools/SchoolsSlice";
import teachersReducer from "./teachers/TeachersSlice";

// Configure the Redux store
export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    classes: classesReducer,
    students: studentsReducer,
    attendance: attendanceReducer,
    schools: schoolsReducer,
    teachers: teachersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

// Export types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
